<!-- <mat-form-field class="mat-form-field-no-padding" style="width: 100%; height: auto;" appearance="outline" floatLabel="auto"> -->
    <input 
        #inputElement
        matInput 
        [placeholder]="placeholder" 
        [formControl]="formControl" 
        [matAutocomplete]="auto"
        (keydown)="onKeyDown($event)"
        (blur)="validateSelection()"
        [tabIndex]="tabIndex"
        class="autocomplete-option"
        [style.--option-color]="colorcode"
        />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)" class="custom-autocomplete-pane">
        <cdk-virtual-scroll-viewport itemSize="50" class="options-viewport">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                <span class="autocomplete-option" [style.--option-color]="colorcode">{{ option }}</span>
            </mat-option>
        </cdk-virtual-scroll-viewport>
    </mat-autocomplete>
    <!-- <mat-error *ngIf="isrequired && formControl.invalid && formControl.touched">
        This field is required.
      </mat-error>
</mat-form-field>-->
<a #fakeclick></a> 